'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var TafSdk = require('@huyafed/web-signal-sdk');
var clientBrowserUa = require('@huyafed/client-browser-ua');
var huyaKiwi = require('@huyafed/huya-kiwi');
var tafcode = require('@huyafed/tafcode');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e["default"] : e; }

var TafSdk__default = /*#__PURE__*/_interopDefaultLegacy(TafSdk);
var clientBrowserUa__default = /*#__PURE__*/_interopDefaultLegacy(clientBrowserUa);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

// 重写这个方法，确保接口返回的字符串都能转义
TafSdk.Taf.BinBuffer.prototype.readString = function (value) {
  var arr = [];
  for (var i = 0; i < value; ) {
    arr.push(String.fromCharCode(this.vew.getUint8(this.position++)));
    i++;
  }
  var result = arr.join('');
  try {
    result = decodeURIComponent(escape(result));
  } catch (e) {}
  // 无脑转义
  result = result
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\'/g, '&#39;')
    .replace(/\"/g, '&quot;');
  return result
};
var HUYA = {};
HUYA.UserId = function () {
  this.lUid = 0;
  this.sGuid = '';
  this.sToken = '';
  this.sHuYaUA = '';
  this.sCookie = '';
  this.iTokenType = 0;
  this.sDeviceInfo = '';
};

HUYA.UserId.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.sGuid = is.readString(1, false, this.sGuid);
  this.sToken = is.readString(2, false, this.sToken);
  this.sHuYaUA = is.readString(3, false, this.sHuYaUA);
  this.sCookie = is.readString(4, false, this.sCookie);
  this.iTokenType = is.readInt32(5, false, this.iTokenType);
  this.sDeviceInfo = is.readString(6, false, this.sDeviceInfo);
};

HUYA.UserId.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeString(1, this.sGuid);
  os.writeString(2, this.sToken);
  os.writeString(3, this.sHuYaUA);
  os.writeString(4, this.sCookie);
  os.writeInt32(5, this.iTokenType);
  os.writeString(6, this.sDeviceInfo);
};

HUYA.UserId.prototype._clone = function () {
  return new HUYA.UserId()
};
HUYA.UserId.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.UserId.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
};

HUYA.ActivityMsgRsp = function () {
  this.iEnable = 0;
  this.vSerializedMsg = new TafSdk.Taf.Vector(new HUYA.ActivitySerializedMsg());
  this.iTimeStamp = 0;
  this.iActivityId = 0;
};

HUYA.ActivityMsgRsp.prototype.readFrom = function (is) {
  this.iEnable = is.readInt32(0, false, this.iEnable);
  this.vSerializedMsg = is.readVector(1, false, this.vSerializedMsg);
  this.iTimeStamp = is.readInt32(2, false, this.iTimeStamp);
  this.iActivityId = is.readInt32(3, false, this.iActivityId);
};

HUYA.ActivityMsgRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iEnable);
  os.writeVector(1, this.vSerializedMsg);
  os.writeInt32(2, this.iTimeStamp);
  os.writeInt32(3, this.iActivityId);
};

HUYA.ActivityMsgRsp.prototype._clone = function () {
  return new HUYA.ActivityMsgRsp()
};
HUYA.ActivityMsgRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.ActivityMsgRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
};

HUYA.ActivitySerializedMsg = function () {
  this.iSubUri = 0;
  this.vContent = new TafSdk.Taf.BinBuffer();
};

HUYA.ActivitySerializedMsg.prototype.readFrom = function (is) {
  this.iSubUri = is.readInt32(0, false, this.iSubUri);
  this.vContent = is.readBytes(1, false, this.vContent);
};

HUYA.ActivitySerializedMsg.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iSubUri);
  os.writeBytes(1, this.vContent);
};

HUYA.ActivitySerializedMsg.prototype._clone = function () {
  return new HUYA.ActivitySerializedMsg()
};
HUYA.ActivitySerializedMsg.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.ActivitySerializedMsg.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
};

HUYA.ActivityMsgReq = function () {
  this.tUserId = new HUYA.UserId();
  this.iActivityId = 0;
  this.lPid = 0;
  this.lTid = 0;
  this.lSid = 0;
  this.iChannelType = 0;
  this.iSubUri = 0;
};

HUYA.ActivityMsgReq.prototype.readFrom = function (is) {
  this.tUserId = is.readStruct(0, false, this.tUserId);
  this.iActivityId = is.readInt32(1, false, this.iActivityId);
  this.lPid = is.readInt64(2, false, this.lPid);
  this.lTid = is.readInt64(3, false, this.lTid);
  this.lSid = is.readInt64(4, false, this.lSid);
  this.iChannelType = is.readInt32(5, false, this.iChannelType);
  this.iSubUri = is.readInt32(6, false, this.iSubUri);
};

HUYA.ActivityMsgReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tUserId);
  os.writeInt32(1, this.iActivityId);
  os.writeInt64(2, this.lPid);
  os.writeInt64(3, this.lTid);
  os.writeInt64(4, this.lSid);
  os.writeInt32(5, this.iChannelType);
  os.writeInt32(6, this.iSubUri);
};

HUYA.ActivityMsgReq.prototype._clone = function () {
  return new HUYA.ActivityMsgReq()
};
HUYA.ActivityMsgReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.ActivityMsgReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def)
};

var HUYA$1 = HUYA;

/**
 * 获取某个cookie
 * @param cookieName cookie的key
 * @returns null | string
 */
var getCookie = function (cookieName) {
    var cookieString = document.cookie;
    var cookies = cookieString.split(';');
    for (var idx = 0; idx < cookies.length; idx += 1) {
        var cookie = cookies[idx];
        var start = cookie.indexOf(cookieName + '=');
        if (start === -1 || start > 1)
            continue;
        start += cookieName.length + 1;
        return cookie.substring(start);
    }
    return null;
};
/**
 * 请求体转为buffer
 * @param funcName 注册函数名
 * @param func 函数名
 * @param data 请求结构体
 * @param requestId 请求id
 * @returns buffer
 */
var createArrayBufferByWupReq = function (serventName, func, data) {
    var wup = new TafSdk.Taf.Wup();
    wup.setServant(serventName);
    wup.setFunc(func);
    if (data)
        wup.writeStruct('tReq', data);
    var os = wup.encode();
    return os.getBuffer();
};
/**
 * 转换buffer
 * @param arrayBuffer buffer
 * @param rspClass 响应结构体
 * @returns
 */
var getWupStructByArrayBuffer = function (arrayBuffer, RspClass) {
    var wup = new TafSdk.Taf.Wup();
    wup.decode(arrayBuffer);
    var key = wup.newdata.get('tRsp') ? 'tRsp' : 'tResp';
    var wupStruct = new RspClass();
    wupStruct._code = wup.readInt32('');
    wup.readStruct(key, wupStruct, RspClass);
    return wupStruct;
};
function checkUserAgent() {
    var appUa = navigator.userAgent;
    var pattern = /(?:ios|adr)\/(\d+\.\d+\.\d+)/;
    return pattern.test(appUa);
}
/**
 * 判断是否是KIWI-HD
 * */
function isIpadKiwiHD(huyaUa) {
    if (!/iPad/.test(navigator.userAgent))
        return false;
    if (!clientBrowserUa__default.isHuyaApp())
        return false;
    return /ipad/.test(huyaUa);
}
function formatTafUa(ua) {
    // 分割UA为数组
    var parts = ua.split('&');
    // 补足前4部分（空字符串填充）
    while (parts.length < 4) {
        parts.push('');
    }
    // 截取前4部分并拼接xxx
    return parts.slice(0, 4).join('&') + "&";
}
/**
 * 增强版深度替换函数，对框架响应式系统提供额外兼容
 * @param {Object} obj - 源对象
 * @param {any} replacement - 替换值
 * @returns {Object} - 替换后的新对象
 */
function deepReplaceShuYaUA(obj, replacement) {
    // 如果是原始类型或null，直接返回
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    // 检测对象是否可能是框架的响应式对象
    var maybeReactive = 
    // Vue 2/3 响应式对象检测
    obj.__ob__ ||
        obj.__v_isRef ||
        obj.__v_reactive ||
        // React风格对象检测
        (Object.isFrozen(obj) && obj.$$typeof);
    // 尝试获取原始对象（如果是响应式对象）
    var rawObj = maybeReactive && typeof obj.valueOf === 'function' ? obj.valueOf() : obj;
    // 处理循环引用
    var visited = new WeakMap();
    function clone(source) {
        // 处理原始值
        if (source === null || typeof source !== 'object') {
            return source;
        }
        // 处理已访问过的对象（循环引用）
        if (visited.has(source)) {
            return visited.get(source);
        }
        // 处理数组
        if (Array.isArray(source)) {
            var cloneArr_1 = [];
            visited.set(source, cloneArr_1);
            source.forEach(function (item, index) {
                cloneArr_1[index] = clone(item);
            });
            return cloneArr_1;
        }
        // 预防特殊对象类型
        if (source instanceof Date ||
            source instanceof RegExp ||
            source instanceof Error ||
            source instanceof Map ||
            source instanceof Set ||
            // 处理DOM节点和Window对象
            (typeof window !== 'undefined' &&
                (source instanceof HTMLElement || source === window))) {
            return source;
        }
        // 处理对象 - 保持原型链
        var sourceProto = Object.getPrototypeOf(source);
        var destination = Object.create(sourceProto);
        // 记录当前对象，防止循环引用
        visited.set(source, destination);
        // 获取所有属性，包括不可枚举的和Symbol
        var allProps = __spread(Object.getOwnPropertyNames(source), Object.getOwnPropertySymbols(source));
        // 过滤掉框架特定的内部属性
        var filteredProps = allProps.filter(function (prop) {
            var propStr = String(prop);
            return !((propStr.startsWith('__v_') || // Vue 3 内部属性
                propStr.startsWith('__') || // 一般内部属性
                propStr === '$$typeof' || // React 内部属性
                propStr === '_owner') // React 内部属性
            );
        });
        filteredProps.forEach(function (prop) {
            if (!Object.getOwnPropertyDescriptor(source, prop)) {
                return; // 跳过不存在或无法访问的属性
            }
            try {
                var descriptor = Object.getOwnPropertyDescriptor(source, prop);
                // 判断是否为 sHuYaUA 键
                if (prop === 'sHuYaUA') {
                    // 替换 sHuYaUA 值
                    Object.defineProperty(destination, prop, {
                        configurable: true,
                        enumerable: descriptor.enumerable,
                        writable: true,
                        value: replacement,
                    });
                }
                else if (descriptor.get || descriptor.set) {
                    // 处理 getter/setter
                    Object.defineProperty(destination, prop, descriptor);
                }
                else {
                    // 处理普通值属性，递归克隆
                    Object.defineProperty(destination, prop, {
                        configurable: true,
                        enumerable: descriptor.enumerable,
                        writable: true,
                        value: clone(descriptor.value),
                    });
                }
            }
            catch (err) {
                // 忽略无法处理的属性
                console.warn("\u65E0\u6CD5\u5904\u7406\u5C5E\u6027 " + String(prop) + ":", err);
            }
        });
        return destination;
    }
    return clone(rawObj);
}
// 判断当前调用页面是否为diy或者普通h5
function pageType(customString) {
    var _a;
    var ztId = window.ztId || '';
    var currentHost = window.location.hostname;
    var purePath = window.location.pathname.split('?')[0];
    var pathSegments = purePath.split('/').filter(Boolean);
    var domainRegex = /^(diyzt-webtest\.cdn\.huya\.com|zt\.huya\.com)$/;
    var isDiyUrl = domainRegex.test(currentHost);
    var str = '';
    if (isDiyUrl) {
        var targetType = pathSegments.find(function (seg) { return seg === 'mobile' || seg === 'pc'; });
        str = "diy" + (targetType === 'pc' ? 'pc' : 'h5') + "_" + ztId + (customString ? '_' + customString : '');
    }
    else {
        var projectId = ((_a = window === null || window === void 0 ? void 0 : window.tiger) === null || _a === void 0 ? void 0 : _a.GITLAB_PROJECT_ID) || window.location.pathname;
        str = "h5_" + projectId + (customString ? '_' + customString : '');
    }
    return str;
}

var Taf = TafSdk.Taf;
// 需要再import
// window.Taf = sdkTaf;
// 重写这个方法，确保接口返回的字符串都能转义
Taf.BinBuffer.prototype.readString = function (value) {
    var arr = [];
    for (var i = 0; i < value;) {
        arr.push(String.fromCharCode(this.vew.getUint8(this.position++)));
        i++;
    }
    var result = arr.join('');
    try {
        result = decodeURIComponent(escape(result));
    }
    catch (e) { }
    // 无脑转义
    result = result
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\'/g, '&#39;')
        .replace(/\"/g, '&quot;');
    return result;
};
// @ts-ignore
huyaKiwi.HYWup.sendWupRequest; var registerGroup = huyaKiwi.HYWup.registerGroup, unRegisterGroup = huyaKiwi.HYWup.unRegisterGroup, sendRequest = huyaKiwi.HYWup.sendRequest;
/**
 * TafNetwork工具
 */
var TafNetwork = /** @class */ (function () {
    function TafNetwork(payload) {
        var _this_1 = this;
        if (payload === void 0) { payload = {}; }
        // @ts-ignore
        this._isManualInit = false;
        this._isInitialized = false;
        /**
         * 顺序Mock actUris
         * @returns never
         */
        this.urisMock = function () { return __awaiter(_this_1, void 0, void 0, function () {
            var urisKeys, _loop_1, this_1, out_i_1, i;
            var _this_1 = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.mockPlugin && typeof this.mockPlugin === 'function'))
                            return [2 /*return*/];
                        urisKeys = this.actUrisKeys;
                        _loop_1 = function (i) {
                            var rsp, keys;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!this_1.actUris[urisKeys[i]].useMock) return [3 /*break*/, 2];
                                        return [4 /*yield*/, new Promise(function (resolve) {
                                                setTimeout(function () {
                                                    resolve(_this_1.mockPlugin(_this_1.actUris[urisKeys[i]].rspStruct, _this_1.actUris[urisKeys[i]].data || {}, 1, '', {}, _this_1.mockTime, _this_1.pid));
                                                }, _this_1.actUris[urisKeys[i]].mockTime || 1000);
                                            })];
                                    case 1:
                                        rsp = _a.sent();
                                        keys = Object.keys(this_1.urisCallBack).map(function (uri) { return uri.toString(); });
                                        if (keys.indexOf(urisKeys[i]) !== -1) {
                                            this_1.log(urisKeys[i], rsp, 3);
                                            this_1.urisCallBack[urisKeys[i]](rsp);
                                        }
                                        else {
                                            this_1.log(urisKeys[i], '', 4);
                                        }
                                        _a.label = 2;
                                    case 2:
                                        i += 1;
                                        out_i_1 = i;
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < urisKeys.length)) return [3 /*break*/, 4];
                        return [5 /*yield**/, _loop_1(i)];
                    case 2:
                        _a.sent();
                        i = out_i_1;
                        _a.label = 3;
                    case 3: return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // 初始化参数
        this.initNormalOptions(payload);
        this._initPromise = this._internalInit(payload);
    }
    TafNetwork.prototype.init = function (payload) {
        if (payload === void 0) { payload = {}; }
        this.initNormalOptions(payload);
        this._isManualInit = true;
        this._isInitialized = false;
        this._initPromise = this._internalInit(payload);
        return this._initPromise;
    };
    TafNetwork.prototype._internalInit = function (payload) {
        if (payload === void 0) { payload = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var res, inBrowser, appInfoObj, e_1, catchAppInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        res = void 0;
                        inBrowser = !clientBrowserUa__default.isHuyaApp() &&
                            !clientBrowserUa__default.isHuyaPc() &&
                            !clientBrowserUa__default.isHuyaMainWeb() &&
                            !clientBrowserUa__default.isHuyaZs() &&
                            !clientBrowserUa__default.isHuyaPcAnchor();
                        if (!((window.self !== window.top && clientBrowserUa__default.isHuyaApp()) ||
                            inBrowser)) return [3 /*break*/, 1];
                        res = {
                            appVersion: '0.0.1',
                            systemVersion: '0.0.1',
                            appName: 'app_iframe',
                            huyaUA: "app_iframe&0.0.1&websocket&&",
                            privilegeUseIAP: '',
                            experiment: '',
                        };
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, huyaKiwi.HYDevice.getAppInfo().catch(function (err) {
                            return {
                                appVersion: '0.0.1',
                                systemVersion: '0.0.1',
                                appName: err.platformValue,
                                huyaUA: err.platformValue + "&0.0.1&websocket&&",
                                privilegeUseIAP: '',
                                experiment: '',
                            };
                        })];
                    case 2:
                        res = _a.sent();
                        _a.label = 3;
                    case 3:
                        appInfoObj = {
                            status: 'ok',
                            systemVersion: res.systemVersion,
                            appVersion: res.appVersion,
                            code: 0,
                            appName: res.appName,
                            huyaUA: res.huyaUA,
                        };
                        this.initOptions(payload, appInfoObj);
                        this._isInitialized = true;
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        catchAppInfo = {
                            status: 'fail',
                            systemVersion: '0.0.1',
                            appVersion: '0.0.1',
                            code: 9999,
                            appName: e_1.platformValue,
                            huyaUA: e_1.platformValue + "&0.0.1&websocket&&",
                        };
                        this.initOptions(payload, catchAppInfo);
                        this._isInitialized = true;
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // 改造关键方法
    TafNetwork.prototype._waitForInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this._isInitialized) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._initPromise];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    TafNetwork.prototype.defineTafUa = function (appInfo, customUa) {
        var tafUa = formatTafUa(appInfo.huyaUA);
        // 如果传入了自定义的ua，则使用自定义的ua
        if (customUa) {
            return customUa;
        }
        // 处理第5位规则逻辑
        var fiveString = pageType(this.customUaString);
        return "" + tafUa + fiveString;
    };
    TafNetwork.prototype.initNormalOptions = function (payload) {
        if (payload === void 0) { payload = {}; }
        var showLog = payload.showLog, isDebug = payload.isDebug, noConnect = payload.noConnect, useMock = payload.useMock, mockTime = payload.mockTime, uid = payload.uid, pid = payload.pid, extraGroups = payload.extraGroups, appId = payload.appId, enableTrace = payload.enableTrace, customHeaders = payload.customHeaders, uris = payload.uris, activity = payload.activity, mockPlugin = payload.mockPlugin, verifyToken = payload.verifyToken, tryTime = payload.tryTime, extraMap = payload.extraMap, needGetActivityMsg = payload.needGetActivityMsg, serialConnect = payload.serialConnect;
        this.showLog = showLog || false;
        this.isDebug = isDebug || false;
        this.noConnect = noConnect;
        this.useMock = isDebug ? useMock || false : false;
        this.mockTime = mockTime || 1000;
        this.uid = uid || parseInt(getCookie('yyuid'), 10) || 0;
        this.pid = pid || 0;
        this.extraGroups = extraGroups || [];
        this.appId = appId || 'HUYA';
        this.enableTrace = enableTrace;
        this.customHeaders = customHeaders;
        this.mockPlugin = undefined;
        this.verifyToken = verifyToken;
        this.tryTime = tryTime || 8;
        this.extraMap = extraMap || {};
        // 是否需要默认请求getActivityMsg接口，一般只有营收活动才需要
        this.needGetActivityMsg =
            typeof needGetActivityMsg !== 'undefined' ? needGetActivityMsg : true;
        // 走web socket通道时，是否使用串行， 0是并行，1为串行
        this.serialConnect =
            typeof serialConnect !== 'undefined' ? serialConnect : 1;
        this.hasListen = false;
        // 内置1010003
        this.uris = {
            1010003: HUYA$1.ActivityMsgRsp,
        };
        if (uris) {
            this.uris = Object.assign({}, this.uris, uris);
        }
        // 一级协议号，用于注册
        this.uriKeys = Object.keys(this.uris).map(function (item) { return item.toString(); }) || [];
        // 活动id，用于getActivityMessage
        this.actId = activity ? activity.actId : 0;
        // 活动二级协议
        this.actUris = activity ? activity.actUris : {};
        // 二级协议号
        this.actUrisKeys =
            Object.keys(this.actUris).map(function (item) { return item.toString(); }) || [];
        // 一二级协议回调
        this.urisCallBack = {};
        this.webSignalSdkOnCalls = {};
        // tafInit 对象
        this.signalSdk = undefined;
        // 接口注册信息，用于防止多次注册
        this.wupList = {};
        // 初始化mokcPlugin
        if (mockPlugin && typeof mockPlugin === 'function') {
            this.mockPlugin = mockPlugin;
        }
    };
    TafNetwork.prototype.initOptions = function (payload, appInfo) {
        if (payload === void 0) { payload = {}; }
        var isApp = payload.isApp, ua = payload.ua, customUaString = payload.customUaString;
        // 默认webh5&0.0.1&activity&对应的客户端
        // 处理TAF UA相关
        this.customUaString = customUaString;
        this.ua = this.defineTafUa(appInfo, ua);
        // 虎牙app内默认isApp=true，其他默认false
        var normalIsApp = clientBrowserUa__default.isHuyaApp();
        // 如果传入isApp则使用传入的值，否则使用默认值 同时检查ua是否是新版本app，如果是则认为是app, 并且要非kiwiHD
        this.isApp =
            (typeof isApp !== 'undefined' ? isApp : normalIsApp) &&
                checkUserAgent() &&
                !isIpadKiwiHD(appInfo.huyaUA);
        // 接口性能上报
        if (!this.isApp) {
            this.signalSdk = this.link();
            this.signalSdk &&
                this.signalSdk.setReportAPI &&
                this.signalSdk.setReportAPI(function (data) {
                    // 优先performanceInfo上报
                    if (window.performanceInfo && window.performanceInfo._hmt) {
                        window.performanceInfo._hmt.push([
                            'reportApiTime',
                            data.funcName,
                            data.state,
                            data.state === 'start' ? data.startTime : data.endTime,
                            'sendWup:' + data.funcName,
                            data.startTime,
                        ]);
                        // hyReport上报
                    }
                    else if (window.hyReport && window.hyReport.hmt) {
                        window.hyReport.hmt.push({
                            handle: 'apiTime',
                            data: {
                                apiName: data.funcName,
                                unique: data.startTime,
                                identity: {
                                    status: data.state,
                                    times: +new Date(),
                                },
                                msg: '',
                            },
                        });
                    }
                });
        }
    };
    TafNetwork.prototype.isEmptyObject = function (obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    };
    /**
     * 初始化web-signal-sdk
     * @returns TafSdk
     */
    TafNetwork.prototype.link = function () {
        var _this_1 = this;
        var baseInit = {
            appSrc: this.appId + "&ZH&2052",
            APPID: this.appId,
            uid: this.uid,
            ua: "" + this.ua,
            isDebug: this.isDebug,
            tryTime: this.tryTime,
            serialConnect: this.serialConnect,
        };
        if (this.noConnect !== undefined) {
            baseInit.noConnect = this.noConnect ? 0 : 1;
        }
        if (this.enableTrace !== undefined) {
            baseInit.enableTrace = this.enableTrace;
        }
        if (this.customHeaders !== undefined) {
            baseInit.customHeaders = this.customHeaders;
        }
        // 透传token校验参数
        if (this.verifyToken !== undefined) {
            baseInit.verifyToken = this.verifyToken;
        }
        // 透传额外的extraMap内的字段
        var extraObj = this.extraMap;
        var isEmpty = this.isEmptyObject(extraObj);
        if (!isEmpty) {
            for (var key in extraObj) {
                if (extraObj.hasOwnProperty(key)) {
                    baseInit[key] = extraObj[key];
                }
            }
        }
        this.log('Start to init', baseInit);
        var startTime = +new Date();
        var reportFlag = false;
        // 建连前埋点
        if (this.noConnect || this.noConnect === undefined) {
            window.performanceInfo &&
                window.performanceInfo._hmt.push([
                    'reportApiTime',
                    'wsConnectTime',
                    'start',
                    startTime,
                    '',
                    startTime,
                ]);
        }
        var signalSdk = new TafSdk.init(baseInit);
        var groups = __spread(['live:' + this.pid], this.extraGroups);
        // 先正常进组
        this.log('Start registering group', groups, 0);
        signalSdk.sendRegisterGroup(groups);
        // 监听链接状态
        signalSdk.on(TafSdk__default.events.WEBSOCKET_CONNECTED, function () {
            if (!reportFlag) {
                reportFlag = true;
                window.performanceInfo &&
                    window.performanceInfo._hmt.push([
                        'reportApiTime',
                        'wsConnectTime',
                        'end',
                        +new Date(),
                        '',
                        startTime,
                    ]);
            }
            // 链接完成后进组，防止断开重连后不进组的情况
            _this_1.log('Start registering group', groups, 0);
            signalSdk.sendRegisterGroup(groups);
            _this_1.log('Websocket connect successfully');
        });
        signalSdk.on(TafSdk__default.events.WS_REGISTER_GROUP_RSP, function () {
            _this_1.log('RegisterGroup successfully');
        });
        signalSdk.on(TafSdk__default.events.WS_UNREGISTER_GROUP_RSP, function () {
            _this_1.log('UnRegisterGroup successfully');
        });
        signalSdk.on(TafSdk__default.events.VERIFYCOOKIE_PASS, function (isPass) {
            _this_1.log("cookie", { isPass: isPass });
        });
        return signalSdk;
    };
    /**
     * 注册监听以及进组
     */
    TafNetwork.prototype.listen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var groups, that_1, filteredGroups;
            var _this_1 = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._waitForInit()];
                    case 1:
                        _a.sent();
                        if (this.hasListen)
                            return [2 /*return*/];
                        this.hasListen = true;
                        // 配置了二级协议,就主动请求getActivityMsg
                        if (this.actUrisKeys.length !== 0 && this.needGetActivityMsg) {
                            this.getActivityMsg();
                            this.urisMock();
                        }
                        groups = __spread(['live:' + this.pid], this.extraGroups);
                        if (this.isApp) {
                            that_1 = this;
                            filteredGroups = groups.filter(function (group) { return !/^(live:|chat:)/.test(group); });
                            // app 进组
                            registerGroup({
                                groupIds: filteredGroups,
                            })
                                .then(function (res) {
                                console.log('app registerGroup success =====>', res);
                            })
                                .catch(function (res) {
                                console.log('app registerGroup catch =====>', res);
                            });
                            huyaKiwi.HUYASdk.addEventListener(huyaKiwi.HUYASdk.EVENT_ID.WUP_TRANSMIT, {
                                subUris: that_1.uriKeys,
                            }, function (resp) {
                                // 不是所有接口都有status,没status有data就直接解包，有status就判断为true再解包
                                var status = resp.status, data = resp.data;
                                if (status) {
                                    if (status !== 'ok' || !data)
                                        return;
                                }
                                else if (!data) {
                                    return;
                                }
                                var subUri = resp.subUri.toString();
                                if (that_1.uriKeys.indexOf(subUri) !== -1) {
                                    var is = new Taf.JceInputStream(resp.data);
                                    var rsp = new that_1.uris[subUri]();
                                    rsp.readFrom(is);
                                    // 处理活动协议
                                    if (subUri === '1010003') {
                                        that_1.serializedMsg(rsp.vSerializedMsg.value, rsp);
                                    }
                                    else {
                                        var keys = Object.keys(that_1.urisCallBack).map(function (uri) {
                                            return uri.toString();
                                        });
                                        if (keys.indexOf(subUri) !== -1) {
                                            _this_1.log(subUri, rsp, 3);
                                            _this_1.urisCallBack[subUri](rsp);
                                        }
                                        else {
                                            _this_1.log(subUri, '', 4);
                                        }
                                        return;
                                    }
                                }
                            });
                        }
                        else {
                            // 注册
                            this.log('Start registering', this.uriKeys);
                            this.uriKeys.forEach(function (uri) {
                                var tempRsp = _this_1.uris[uri];
                                _this_1.signalSdk && _this_1.signalSdk.registerUri(uri, tempRsp);
                            });
                            // 监听
                            this.uriKeys.forEach(function (uri) {
                                var onHandle = function (resp) {
                                    // 处理活动协议
                                    if (uri === '1010003') {
                                        _this_1.serializedMsg(resp.vSerializedMsg.value, resp);
                                    }
                                    else {
                                        var keys = Object.keys(_this_1.urisCallBack).map(function (uri) {
                                            return uri.toString();
                                        });
                                        if (keys.indexOf(uri) !== -1) {
                                            _this_1.log(uri, resp, 3);
                                            _this_1.urisCallBack[uri](resp);
                                        }
                                        else {
                                            _this_1.log(uri, '', 4);
                                        }
                                    }
                                };
                                _this_1.webSignalSdkOnCalls[uri] = onHandle;
                                _this_1.signalSdk && _this_1.signalSdk.on(uri, onHandle);
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 注册监听
     */
    TafNetwork.prototype.addListener = function (uri, callBack) {
        this.urisCallBack[uri] = callBack;
    };
    /**
     * 清除单个事件监听
     * @param
     * uriKey: 需要移除监听协议号 string类型
     */
    TafNetwork.prototype.clearSingleListen = function (uriKey) {
        if (this.isApp) {
            huyaKiwi.HUYASdk.removeEventListener(huyaKiwi.HUYASdk.EVENT_ID.TRANSMIT, {
                subUris: [uriKey],
            });
        }
        else {
            // 删除本地存储监听回调
            if (this.urisCallBack[uriKey]) {
                delete this.urisCallBack[uriKey];
            }
            // 删除web signalSdk端监听
            if (this.webSignalSdkOnCalls[uriKey]) {
                this.signalSdk &&
                    this.signalSdk.off(uriKey, this.webSignalSdkOnCalls[uriKey]);
            }
            else {
                this.signalSdk && this.signalSdk.off(uriKey);
            }
        }
    };
    /**
     * 清除所有注册及退组
     */
    TafNetwork.prototype.clearAll = function () {
        var _this_1 = this;
        if (!this.hasListen)
            return;
        this.hasListen = false;
        var groups = __spread(['live:' + this.pid], this.extraGroups);
        if (this.isApp) {
            huyaKiwi.HUYASdk.removeEventListener(huyaKiwi.HUYASdk.EVENT_ID.TRANSMIT, {
                subUris: this.uriKeys,
            });
            unRegisterGroup({
                groupIds: groups,
            });
        }
        else {
            this.signalSdk && this.signalSdk.sendUnRegisterGroup(groups);
            this.uriKeys.forEach(function (item) {
                // 删除本地存储监听回调
                if (_this_1.urisCallBack[item]) {
                    delete _this_1.urisCallBack[item];
                }
                // 删除web signalSdk端监听
                if (_this_1.webSignalSdkOnCalls[item]) {
                    _this_1.signalSdk &&
                        _this_1.signalSdk.off(item, _this_1.webSignalSdkOnCalls[item]);
                }
                else {
                    _this_1.signalSdk && _this_1.signalSdk.off(item);
                }
            });
        }
    };
    /**
     * 获取活动推送
     * @returns never
     */
    TafNetwork.prototype.getActivityMsg = function () {
        var reqUser = new HUYA$1.UserId();
        reqUser.lUid = this.uid;
        this.sendWup('getActivityMsg', {
            tUserId: reqUser,
            lPid: this.pid,
            lTid: 0,
            lSid: this.pid,
            iChannelType: 2003,
            iActivityId: this.actId,
        }, HUYA$1.ActivityMsgReq, HUYA$1.ActivityMsgRsp);
    };
    /**
     * 获取礼物ICON
     * @returns icons
     */
    TafNetwork.prototype.getPropsList = function () {
        throw new Error("\u83B7\u53D6\u793C\u7269\u65B9\u6CD5\u79FB\u9664\uFF0C\u8BF7\u4F7F\u7528@huyafed/getPropsDetail\u83B7\u53D6\u793C\u7269\u4FE1\u606F");
    };
    /**
     * 注册函数
     * @param funcName 注册函数名
     * @param SendRsp 函数响应体
     * @returns never
     */
    TafNetwork.prototype.registerWup = function (funcName, SendRsp) {
        // 防止多次调用函数时重复注册
        if (this.wupList[funcName])
            return;
        this.wupList[funcName] = SendRsp;
        this.signalSdk && this.signalSdk.registerWup(funcName, SendRsp);
    };
    /**
     * 规范返回数据
     * @param resp 接口返回
     * @param funcName 接口方法名
     * @param isApp 是否是APP通道调用
     * @returns 规范数据
     */
    TafNetwork.prototype.respClean = function (resp, funcName, isApp, servantName) {
        var bcode = resp.bcode, sdkcode = resp.sdkcode, iRequestId = resp.iRequestId, last = __rest(resp, ["bcode", "sdkcode", "iRequestId"]);
        var _this = this;
        // 性能上报
        this.reportErrorCode(funcName, bcode, sdkcode);
        // 接入 tafcode log 提示 只在测开环境生效
        try {
            if (_this.isDebug && !!tafcode.getErrorMsg(resp)) {
                tafcode.responseCodeChecker({
                    reqParams: {
                        servant: servantName,
                        funcName: funcName,
                    },
                    res: resp,
                    logger: function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        return console.error.apply(console, __spread(args, [{ funcName: funcName, servantName: servantName }]));
                    },
                });
            }
        }
        catch (e) {
            console.log(e);
        }
        // app通道直接原值return，为了统一处理数据上报
        if (isApp) {
            return resp;
        }
        else {
            return {
                bcode: bcode,
                sdkcode: sdkcode,
                iRequestId: iRequestId,
                data: last,
            };
        }
    };
    /**
     * 接口异常数据上报
     * @param funcName 接口方法名
     * @param bcode 接口返回
     * @param sdkcode 接口返回
     * @returns resp
     */
    TafNetwork.prototype.reportErrorCode = function (funcName, bcode, sdkcode) {
        // 测试环境不进行上报
        if (this.isDebug)
            return;
        try {
            // bcode非零时上报数据
            if (bcode !== 0) {
                window.performanceInfo &&
                    window.performanceInfo._hmt.push([
                        'reportApiMess',
                        'taf-error',
                        "" + funcName,
                        "" + bcode,
                    ]);
                window.hyReport &&
                    window.hyReport.hmt.push({
                        handle: 'apiMess',
                        data: {
                            apiName: 'taf-error',
                            msg: "" + funcName,
                            retcode: "" + bcode,
                        },
                    });
            }
            // sdkcode非零时上报数据
            if (sdkcode !== 0) {
                window.performanceInfo &&
                    window.performanceInfo._hmt.push([
                        'reportApiMess',
                        'taf-sdk-error',
                        "" + funcName,
                        "" + sdkcode,
                    ]);
                window.hyReport &&
                    window.hyReport.hmt.push({
                        handle: 'apiMess',
                        data: {
                            apiName: 'taf-sdk-error',
                            msg: "" + funcName,
                            retcode: "" + sdkcode,
                        },
                    });
            }
        }
        catch (e) {
            console.error(e);
        }
    };
    /**
     * 发送taf请求
     * @param funcName 函数名
     * @param data 请求req
     * @param SendReq 函数req
     * @param SendRsp 函数rsp
     * @param servantName 服务名
     * @param mock 定制化mock
     * @param tryCount 重试次数（只有web端请求才有，复用app请求无效）
     * @param extData 扩展参数（只有web端请求才有，复用app请求无效）
     * @returns Promise<TRsp>
     */
    TafNetwork.prototype.sendWup = function (funcName, data, SendReq, SendRsp, servantName, mock, tryCount, extData) {
        if (servantName === void 0) { servantName = 'wupui'; }
        if (mock === void 0) { mock = {}; }
        if (tryCount === void 0) { tryCount = 1; }
        if (extData === void 0) { extData = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _this_1 = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._waitForInit()
                        // 配置了mock
                    ];
                    case 1:
                        _a.sent();
                        // 配置了mock
                        if (this.useMock &&
                            funcName !== 'getActivityMsg' &&
                            typeof this.mockPlugin === 'function')
                            return [2 /*return*/, this.mockPlugin(SendRsp, mock, 2, funcName, data, this.mockTime, this.pid)];
                        return [2 /*return*/, new Promise(function (resolve) {
                                var req = new SendReq();
                                var reqKeys = Object.keys(req);
                                data = deepReplaceShuYaUA(data, _this_1.ua);
                                var dataKeys = Object.keys(data);
                                reqKeys.forEach(function (item) {
                                    if (dataKeys.indexOf(item) !== -1) {
                                        req[item] = data[item];
                                    }
                                });
                                if (_this_1.isApp) {
                                    _this_1.sendAppRequest(funcName, req, SendRsp, servantName).then(function (resp) {
                                        return resolve(resp);
                                    });
                                }
                                else {
                                    _this_1.sendWupWeb(funcName, req, SendRsp, servantName, tryCount, extData).then(function (resp) { return resolve(resp); });
                                }
                            })];
                }
            });
        });
    };
    /**
     * 发送taf请求, 不重写UA版本，提供给某些老业务接口指定ua的场景调用
     * @param funcName 函数名
     * @param data 请求req
     * @param SendReq 函数req
     * @param SendRsp 函数rsp
     * @param servantName 服务名
     * @param mock 定制化mock
     * @param tryCount 重试次数（只有web端请求才有，复用app请求无效）
     * @param extData 扩展参数（只有web端请求才有，复用app请求无效）
     * @returns Promise<TRsp>
     */
    TafNetwork.prototype.sendWupWithForceUa = function (funcName, data, SendReq, SendRsp, servantName, mock, tryCount, extData) {
        if (servantName === void 0) { servantName = 'wupui'; }
        if (mock === void 0) { mock = {}; }
        if (tryCount === void 0) { tryCount = 1; }
        if (extData === void 0) { extData = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _this_1 = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._waitForInit()
                        // 配置了mock
                    ];
                    case 1:
                        _a.sent();
                        // 配置了mock
                        if (this.useMock &&
                            funcName !== 'getActivityMsg' &&
                            typeof this.mockPlugin === 'function')
                            return [2 /*return*/, this.mockPlugin(SendRsp, mock, 2, funcName, data, this.mockTime, this.pid)];
                        return [2 /*return*/, new Promise(function (resolve) {
                                var req = new SendReq();
                                var reqKeys = Object.keys(req);
                                var dataKeys = Object.keys(data);
                                reqKeys.forEach(function (item) {
                                    if (dataKeys.indexOf(item) !== -1) {
                                        req[item] = data[item];
                                    }
                                });
                                if (_this_1.isApp) {
                                    _this_1.sendAppRequest(funcName, req, SendRsp, servantName).then(function (resp) {
                                        return resolve(resp);
                                    });
                                }
                                else {
                                    _this_1.sendWupWeb(funcName, req, SendRsp, servantName, tryCount, extData).then(function (resp) { return resolve(resp); });
                                }
                            })];
                }
            });
        });
    };
    /** 返回Taf对象 **/
    TafNetwork.prototype.getTaf = function () {
        return Taf;
    };
    /**
     * web端接口请求
     * @param funcName 函数名
     * @param req 请求体
     * @param SendRsp 请求响应体
     * @param servantName 服务名
     * @param tryCount 重试次数
     * @param extData 扩展字段 { wupTimeOut: 服务器超时时间}
     * @returns Promise<TRsp>
     */
    TafNetwork.prototype.sendWupWeb = function (funcName, req, SendRsp, servantName, tryCount, extData) {
        var _this_1 = this;
        if (tryCount === void 0) { tryCount = 1; }
        return new Promise(function (resolve) {
            _this_1.log(funcName, __assign({}, req), 1);
            // 注册函数
            _this_1.registerWup(funcName, SendRsp);
            // 发起请求
            _this_1.signalSdk.sendWup(servantName, funcName, req, function (resp) {
                _this_1.log(funcName, resp, 2);
                if (funcName === 'getActivityMsg') {
                    _this_1.serializedMsg(resp.vSerializedMsg.value, resp);
                }
                resolve(_this_1.respClean(resp, funcName, false, servantName));
            }, tryCount, extData);
        });
    };
    /**
     * app端接口请求
     * @param funcName 函数名
     * @param req 请求体
     * @param SendRsp 请求响应体
     * @param servantName 服务名
     * @returns Promise<TRsp>
     */
    // @ts-ignore
    // private sendWupApp(funcName, req, SendRsp, servantName): Promise<TRsp> {
    //   const that = this
    //   const rsp = {
    //     bcode: -1,
    //     sdkcode: -1,
    //     data: new SendRsp(),
    //     iRequestId: 0,
    //   }
    //   const arrayBuffer = createArrayBufferByWupReq(servantName, funcName, req)
    //   return new Promise((resolve) => {
    //     // 接口兜底，10s后无响应就返回超时
    //     let hasTimeOut = false
    //     const timer = setTimeout(() => {
    //       if (!hasTimeOut) {
    //         hasTimeOut = true
    //         // 请求8S超时，返回-1。对齐web sdk
    //         this.log(funcName, '接口请求超时', 2)
    //         this.log(funcName, rsp, 2)
    //         resolve(that.respClean(rsp, funcName, true, servantName))
    //       }
    //       clearTimeout(timer)
    //     }, 10000)
    //     // 上报
    //     const startTime = +new Date()
    //     if (window.performanceInfo && window.performanceInfo._hmt) {
    //       window.performanceInfo._hmt.push([
    //         'reportApiTime',
    //         funcName,
    //         'start',
    //         startTime,
    //         ,
    //         'sendWupApp:' + funcName,
    //         startTime,
    //       ])
    //     } else if (window.hyReport && window.hyReport.hmt) {
    //       window.hyReport.hmt.push({
    //         handle: 'apiTime',
    //         data: {
    //           apiName: funcName,
    //           unique: startTime,
    //           identity: {
    //             status: 'start',
    //             times: +new Date(),
    //           },
    //           msg: '',
    //         },
    //       })
    //     }
    //     this.log(funcName, { ...req }, 1)
    //     // 发起请求
    //     sendWupRequest({
    //       unitPacket: arrayBuffer,
    //       userInfo: {},
    //       // 失败接口ios不会跑进fail，adr则会
    //       // complete(resp) {
    //       //   console.log('complete', resp);
    //       // },
    //       // fail(error) {
    //       //   console.log('error', error);
    //       // },
    //     })
    //       .then((resp: any) => {
    //         if (resp.status !== 'ok' || rsp.data === undefined) {
    //           // 请求数据有问题，sdkcode返回-3。对齐web sdk
    //           this.log(funcName, '接口请求失败', 2)
    //           rsp.sdkcode = -3
    //           that.log(funcName, rsp, 2)
    //           resolve(that.respClean(rsp, funcName, true, servantName))
    //           return
    //         }
    //         const rspData = getWupStructByArrayBuffer(resp.data, SendRsp)
    //         if (hasTimeOut) return
    //         hasTimeOut = true
    //         // warning: 客户端不支持_code不为0的情况
    //         // ios表现为没有success、complete、fail回调
    //         // adr表现为没有success回调，有complete和fail回调，有_code返回，但无data
    //         if (rspData._code === 0) {
    //           if (window.performanceInfo && window.performanceInfo._hmt) {
    //             window.performanceInfo._hmt.push([
    //               'reportApiTime',
    //               funcName,
    //               'end',
    //               +new Date(),
    //               ,
    //               'sendWupApp:' + funcName,
    //               startTime,
    //             ])
    //           } else if (window.hyReport && window.hyReport.hmt) {
    //             window.hyReport.hmt.push({
    //               handle: 'apiTime',
    //               data: {
    //                 apiName: funcName, // 接口名字
    //                 unique: startTime, // 唯一（时间戳）
    //                 identity: {
    //                   status: 'end', // 前置打点
    //                   times: +new Date(), //  开始请求时间
    //                 },
    //                 msg: '', // 可选项，用于日志分析
    //               },
    //             })
    //           }
    //           // 处理活动请求
    //           if (funcName === 'getActivityMsg') {
    //             that.serializedMsg(rspData.vSerializedMsg.value, rspData)
    //           }
    //           // 抹平差异
    //           delete rspData._code
    //           rsp.bcode = 0
    //           rsp.sdkcode = 0
    //           rsp.iRequestId = 0
    //           rsp.data = rspData
    //           that.log(funcName, rsp, 2)
    //           resolve(that.respClean(rsp, funcName, true, servantName))
    //         } else {
    //           this.log(funcName, `APP接口返回_code:${rspData._code}`, 2)
    //           that.log(funcName, rsp, 2)
    //           resolve(that.respClean(rsp, funcName, true, servantName))
    //         }
    //       })
    //       .catch((err) => {
    //         this.log(
    //           funcName,
    //           `APP接口失败，catch返回err_code:${err.err_code}`,
    //           2
    //         )
    //         hasTimeOut = true
    //         if (window.performanceInfo && window.performanceInfo._hmt) {
    //           window.performanceInfo._hmt.push([
    //             'reportApiTime',
    //             funcName,
    //             'end',
    //             +new Date(),
    //             ,
    //             'sendWupApp:' + funcName,
    //             startTime,
    //           ])
    //         } else if (window.hyReport && window.hyReport.hmt) {
    //           window.hyReport.hmt.push({
    //             handle: 'apiTime',
    //             data: {
    //               apiName: funcName, // 接口名字
    //               unique: startTime, // 唯一（时间戳）
    //               identity: {
    //                 status: 'end', // 前置打点
    //                 times: +new Date(), //  开始请求时间
    //               },
    //               msg: '', // 可选项，用于日志分析
    //             },
    //           })
    //         }
    //         if (err.err_code) {
    //           // 客户端catch到的错误码 直接透传
    //           rsp.bcode = err.err_code
    //           rsp.sdkcode = err.err_code
    //         }
    //         that.log(funcName, rsp, 2)
    //         resolve(that.respClean(rsp, funcName, true, servantName))
    //       })
    //   }) as Promise<TRsp>
    // }
    /**
     * App端接口请求
     *  @param funcName 接口名
     *  @param req 请求参数
     *  @param rspClass 返回参数类
     * @param servantName 服务名
     * @returns Promise<TRsp> 返回参数
     * */
    TafNetwork.prototype.sendAppRequest = function (funcName, req, SendRsp, servantName) {
        var _this_1 = this;
        var that = this;
        var rsp = {
            bcode: -1,
            sdkcode: -1,
            data: new SendRsp(),
            iRequestId: 0,
        };
        var arrayBuffer = createArrayBufferByWupReq(servantName, funcName, req);
        return new Promise(function (resolve) {
            // 接口兜底，8s后无响应就返回超时
            var hasTimeOut = false;
            var timer = setTimeout(function () {
                if (!hasTimeOut) {
                    hasTimeOut = true;
                    // 请求8S超时，返回-1。对齐web sdk
                    _this_1.log(funcName, '接口请求超时', 2);
                    _this_1.log(funcName, rsp, 2);
                    resolve(that.respClean(rsp, funcName, true, servantName));
                }
                clearTimeout(timer);
            }, 8000);
            // 上报
            var startTime = +new Date();
            if (window.performanceInfo && window.performanceInfo._hmt) {
                window.performanceInfo._hmt.push([
                    'reportApiTime',
                    funcName,
                    'start',
                    startTime,
                    'sendAppRequest:' + funcName,
                    startTime,
                ]);
            }
            else if (window.hyReport && window.hyReport.hmt) {
                window.hyReport.hmt.push({
                    handle: 'apiTime',
                    data: {
                        apiName: funcName,
                        unique: startTime,
                        identity: {
                            status: 'start',
                            times: +new Date(),
                        },
                        msg: '',
                    },
                });
            }
            _this_1.log(funcName, __assign({}, req), 1);
            // 发起请求
            sendRequest({
                unitPacket: arrayBuffer,
                servant: servantName,
                funcname: funcName,
            })
                .then(function (resp) {
                // 如果请求成功，接口直接返回jce rsp，没有其他层级和字段
                var rspData = getWupStructByArrayBuffer(resp, SendRsp);
                if (hasTimeOut)
                    return;
                hasTimeOut = true;
                if (window.performanceInfo && window.performanceInfo._hmt) {
                    window.performanceInfo._hmt.push([
                        'reportApiTime',
                        funcName,
                        'end',
                        +new Date(),
                        'sendAppRequest:' + funcName,
                        startTime,
                    ]);
                }
                else if (window.hyReport && window.hyReport.hmt) {
                    window.hyReport.hmt.push({
                        handle: 'apiTime',
                        data: {
                            apiName: funcName,
                            unique: startTime,
                            identity: {
                                status: 'end',
                                times: +new Date(),
                            },
                            msg: "sendAppRequest: " + funcName,
                        },
                    });
                }
                // 处理活动请求
                if (funcName === 'getActivityMsg') {
                    that.serializedMsg(rspData.vSerializedMsg.value, rspData);
                }
                // 抹平差异
                rsp.bcode = 0;
                rsp.sdkcode = 0;
                rsp.iRequestId = 0;
                rsp.data = rspData;
                that.log(funcName, rsp, 2);
                resolve(that.respClean(rsp, funcName, true, servantName));
            })
                .catch(function (err) {
                _this_1.log(funcName, "APP\u63A5\u53E3\u5931\u8D25\uFF0Ccatch\u8FD4\u56DEerror\u4FE1\u606F:" + JSON.stringify(err), 2);
                // 接口失败，清除超时定时器
                hasTimeOut = true;
                // 接口错误返回需要上报接口请求结束时间上报
                if (window.performanceInfo && window.performanceInfo._hmt) {
                    window.performanceInfo._hmt.push([
                        'reportApiTime',
                        funcName,
                        'end',
                        +new Date(),
                        'sendAppRequest:' + funcName,
                        startTime,
                    ]);
                }
                else if (window.hyReport && window.hyReport.hmt) {
                    window.hyReport.hmt.push({
                        handle: 'apiTime',
                        data: {
                            apiName: funcName,
                            unique: startTime,
                            identity: {
                                status: 'end',
                                times: +new Date(),
                            },
                            msg: "sendAppRequest: " + funcName,
                        },
                    });
                }
                var rspData = new SendRsp();
                try {
                    rspData = getWupStructByArrayBuffer(err.message, SendRsp);
                }
                catch (eMsg) {
                    _this_1.log(funcName, "\u89E3\u6790err message\u7ED3\u6784\u4F53\u5931\u8D25\uFF0Ccatch\u8FD4\u56DEerror\u4FE1\u606F:" + JSON.stringify(eMsg), 2);
                }
                if (err.errorCode) {
                    // 客户端catch到的错误码 直接透传
                    rsp.bcode = err.errorCode;
                    rsp.sdkcode = err.errorCode;
                    rsp.data = rspData;
                }
                that.log(funcName, rsp, 2);
                resolve(that.respClean(rsp, funcName, true, servantName));
            });
        });
    };
    /**
     * 处理一级协议和getActivityMsg中的二级协议
     * @param obj
     * @returns never
     */
    TafNetwork.prototype.serializedMsg = function (obj, rsp) {
        var _this_1 = this;
        Array.isArray(obj) &&
            obj.forEach(function (elm) {
                if (_this_1.actUris[elm.iSubUri]) {
                    try {
                        var is = new Taf.JceInputStream(elm.vContent);
                        var response = new _this_1.actUris[elm.iSubUri].rspStruct();
                        response.readFrom(is);
                        _this_1.log(elm.iSubUri, response, 3);
                        var keys = Object.keys(_this_1.urisCallBack).map(function (uri) {
                            return uri.toString();
                        });
                        if (keys.indexOf(elm.iSubUri.toString()) !== -1) {
                            _this_1.urisCallBack[elm.iSubUri](response, rsp);
                        }
                        else {
                            _this_1.log(elm.iSubUri, '', 4);
                        }
                    }
                    catch (err) {
                        throw new Error(err);
                    }
                }
            });
    };
    /**
     * 美化打印信息
     * @param key 函数名
     * @param value 打印值
     * @param type 类型
     * @returns never
     */
    TafNetwork.prototype.log = function (key, value, type) {
        if (value === void 0) { value = ''; }
        if (type === void 0) { type = 0; }
        // 客户端本地log开关
        var localShowLogFlag = true;
        try {
            localShowLogFlag = !localStorage.getItem('TAF_NETWORK_LOCAL_LOG');
        }
        catch (e) { }
        if (this.showLog || !localShowLogFlag) {
            switch (type) {
                case 0:
                    console.log("%c <<<<< %c " + key + " %c >>>>>", 'color: green;', 'color: black;', 'color: green', value);
                    break;
                case 3:
                    console.log("%c <<<<< %c uri: %c" + key + " %c >>>>>", 'color: #E1378C;', 'color: black;font-weight: bold;', 'color: #E1378C;font-weight: bold;', 'color: #E1378C;', value);
                    break;
                case 4:
                    console.log("%c <<<<< %c \u6536\u5230\u672A\u5904\u7406\u8BF7\u6C42: %c" + key + " %c >>>>>", 'color: red;', 'color: black;', 'color: black;', 'color: red;');
                    break;
                case 1:
                    console.log("%c >>>>> %c reqWup: %c" + key + " %c <<<<<", 'color: green;', 'color: black;font-weight: bold;', 'color: green;font-weight: bold;', 'color: green;', value);
                    break;
                case 2:
                    console.log("%c <<<<< %c rspWup: %c" + key + " %c >>>>>", 'color: blue;', 'color: black;font-weight: bold;', 'color: blue;font-weight: bold;', 'color: blue;', value);
                    break;
            }
        }
    };
    return TafNetwork;
}());
window.TafNetwork = TafNetwork;

exports.Taf = Taf;
exports["default"] = TafNetwork;
